import React from 'react';
import PropTypes from 'prop-types';
import styles from './LinkGoogleAccount.scss';

import { t } from '../../../../../../utils/invite-friends-utils';
import { useInviteFriendsContext } from '../../../../../../state/InviteFriendsContext';
import { CLEAR_ALERT } from '../../../../../../state/InviteFriends.actions';

const LinkGoogleAccount = ({ requestContacts }) => {
  const { dispatch, track } = useInviteFriendsContext();

  const handleOnClick = () => {
    track({
      element: 'add_gmail_contacts',
      action: 'click',
      properties: { current_tab: 'email' }
    });
    dispatch({ type: CLEAR_ALERT });
    requestContacts();
  };
  return (
    <>
      <h3 className={styles.headline}>
        {t('modal.email.gmail_request.title')}
      </h3>
      <div className={styles.content}>
        <p>{t('modal.email.gmail_request.message')}</p>
        <p>
          <em>{t('modal.email.gmail_request.disclaimer')}</em>
        </p>
      </div>
      <button
        type="button"
        onClick={handleOnClick}
        data-cy="gmail-contacts-btn"
        className={styles.gmailButton}
      >
        <div className={styles.gmailIcon} />
        <span className={styles.btnLabel}>
          {t('modal.email.gmail_request.button')}
        </span>
      </button>
    </>
  );
};

LinkGoogleAccount.propTypes = {
  requestContacts: PropTypes.func.isRequired
};

export default LinkGoogleAccount;
